import { render, staticRenderFns } from "./AddMilestones.vue?vue&type=template&id=7eb997f2&"
import script from "./AddMilestones.vue?vue&type=script&lang=js&"
export * from "./AddMilestones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eb997f2')) {
      api.createRecord('7eb997f2', component.options)
    } else {
      api.reload('7eb997f2', component.options)
    }
    module.hot.accept("./AddMilestones.vue?vue&type=template&id=7eb997f2&", function () {
      api.rerender('7eb997f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectmanagement/AddMilestones.vue"
export default component.exports